import { getSignedUrl } from 'api/documents';
import { previewFormats } from 'config/document_preview_formats';

export const downloadDocument = async (id, data) => {
  const { url } = await getSignedUrl(id);
  const { path, name } = data;
  const needPreview = shouldGeneratePreview(path);

  // Check for Safari browser
  const isSafari =
    navigator.userAgent.includes('Safari') &&
    !navigator.userAgent.includes('Chrome');

  if (isSafari) {
    await downloadForSafari(url, name, needPreview);
  } else {
    downloadForOtherBrowsers(url, name, needPreview);
  }
};

const downloadForSafari = (url, fileName, needPreview) => {
  const downloadLink = createDownloadLink(url, fileName, needPreview);
  triggerDownload(downloadLink);
  cleanupDownload(downloadLink);
};

const downloadForOtherBrowsers = (url, fileName, needPreview) => {
  const link = createDownloadLink(url, fileName, needPreview);
  triggerDownload(link);
  cleanupDownload(link);
};

const createDownloadLink = (href, fileName, needPreview = false) => {
  const link = document.createElement('a');
  link.href = href;
  link.download = fileName;
  link.rel = 'noopener noreferrer';

  if (needPreview) {
    link.target = '_blank';
  }

  document.body.appendChild(link);
  return link;
};

const triggerDownload = (link) => {
  setTimeout(() => {
    link.click();
  }, 100);
};

const cleanupDownload = (link) => {
  setTimeout(() => {
    document.body.removeChild(link);
  }, 100);
};

export const shouldGeneratePreview = (path) => {
  const fileFormat = getFileFormat(path);

  return fileFormat
    ? previewFormats.some((format) => format === fileFormat)
    : false;
};

export const displaySignButton = (data) =>
  data.type === 'dap' &&
  data.isGenerated &&
  data.signatureStatus === 'not-signed';

const getFileFormat = (path) => {
  if (!path) return;
  const lastDotIndex = path.lastIndexOf('.');
  return lastDotIndex !== -1 ? path.slice(lastDotIndex + 1) : null;
};
